/**
 * Webhook utility functions for sending notifications to external services
 * Server-side version: sends directly to n8n (no proxy needed)
 */

const WEBHOOK_URLS = {
  ORDER_CREATED: 'https://n8n.srv760625.hstgr.cloud/webhook/5d0ff1a0-4eb2-498a-83eb-61094fc1cf78',
  ORDER_PDF_DOWNLOAD: 'https://n8n.srv760625.hstgr.cloud/webhook/pdf-download',
  ORDER_STATUS_UPDATED: 'https://n8n.srv760625.hstgr.cloud/webhook/1fb86e01-4745-422f-a731-459f6e8903c5',
  USER_REGISTERED: 'https://n8n.srv760625.hstgr.cloud/webhook/b4bf410a-4868-43c3-92c8-adbf9df693f1',
};

/**
 * Send a webhook notification to n8n
 * @param webhookKey The webhook key (e.g. 'ORDER_CREATED') or a full URL for backwards compatibility
 * @param data The data to send in the webhook body
 * @param options Additional options
 * @returns True if the webhook was successfully sent, false otherwise
 */
async function sendWebhook(webhookKey, data, options = {}) {
  const { timeout = 30000 } = options;

  // Support both keys and full URLs for backwards compatibility
  const url = WEBHOOK_URLS[webhookKey] || webhookKey;

  try {
    console.log(`Sending webhook [${webhookKey}] for event: ${data.event || 'unknown'}`);
    if (data.pdf_base64) {
      const tmpData = {...data};
      tmpData.pdf_base64 = `[Base64 data - ${Math.round(data.pdf_base64.length / 1024)}KB]`;
      console.log(`Webhook data (base64 truncated):`, JSON.stringify(tmpData, null, 2));
    } else {
      console.log(`Webhook data:`, JSON.stringify(data, null, 2));
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      console.warn(`Webhook [${webhookKey}] failed with status ${response.status}:`, await response.text());
      return false;
    }

    return true;
  } catch (error) {
    console.error(`Error sending webhook [${webhookKey}]:`, error);
    return false;
  }
}

const WEBHOOKS = {
  ORDER_CREATED: 'ORDER_CREATED',
  ORDER_PDF_DOWNLOAD: 'ORDER_PDF_DOWNLOAD',
  ORDER_STATUS_UPDATED: 'ORDER_STATUS_UPDATED',
  USER_REGISTERED: 'USER_REGISTERED',
};

module.exports = { sendWebhook, WEBHOOKS };
